import Skeleton from '@cvent/carina/components/Skeleton';
import {Card} from '../card/Card';
import {useSkeletonDelay} from './useSkeletonDelay';

/**
 * Skeleton for business type selection page
 * Includes a 300ms delay to prevent flash on fast-loading pages
 */
export const BusinessTypeSelectionSkeleton = () => {
  const show = useSkeletonDelay();

  if (!show) {
    return null;
  }

  return (
    <div className="flex justify-center items-start md:[margin-top:var(--carina-spacing-12)]">
      <Card styleClasses="p-4 pt-0 px-6 sm:p-8 sm:pl-6 md:pl-8 max-w-[1099px]">
        {/* Back button skeleton */}
        <div className="[margin-bottom:var(--carina-spacing-8)]">
          <Skeleton className="w-[80px] h-[32px] rounded" hasShimmer />
        </div>

        {/* Title skeleton */}
        <div className="[margin-bottom:var(--carina-spacing-8)]">
          <Skeleton className="w-[280px] h-[28px] rounded" hasShimmer />
        </div>

        {/* Business cards grid skeleton */}
        <div className="flex flex-wrap justify-start md:justify-center items-start md:items-center gap-6 sm:[gap:var(--carina-spacing-4)] md:[gap:var(--carina-spacing-14)]">
          {Array.from({length: 5}).map((_, index) => (
            <Skeleton
              key={index}
              className="h-[148px] w-[132px] sm:w-[175px] sm:h-[151px] rounded-lg"
              hasShimmer
            />
          ))}
        </div>
        {/* Next button skeleton */}
        <div className="flex justify-center items-center [margin-top:var(--carina-spacing-8)]">
          <Skeleton className="w-[300px] h-[40px] rounded" hasShimmer />
        </div>
      </Card>
    </div>
  );
};
